/**
 * Created by lu on 2017/9/11.
 */
var nb = require('../nb');
var inputSubmit = require('./form/InputSubmit');
module.exports = nb.define({
    view: {
        $html: {
            'class': 'footer',
            $html: [{
                'class': "logo",
                $html: {
                    tag: 'img',
                    src: './image/logo/logo-white.svg'
                }
            }, {
                'class': 'footer-content clearfix',
                $html: [
                    {
                        // 'class':'footer-list-1',
                        // tag:'ul',
                        // $html:[{
                        //     'tag':'li',
                        //     'class':'about-company',
                        //     $html:[{
                        //         'class':'title footer-label',
                        //         $text:'关于公司'
                        //     },{
                        //         'class':"list",
                        //         tag:'ul',
                        //         $html:[{
                        //             'tag':'li',
                        //             $text:'关于'
                        //         },{
                        //             'tag':'li',
                        //             $text:'企业责任'
                        //         },{
                        //             'tag':'li',
                        //             $text:'职业发展'
                        //         },{
                        //             'tag':'li',
                        //             $text:'细则及条款'
                        //         },{
                        //             'tag':'li',
                        //             $text:'隐私与COOKIE'
                        //         },{
                        //             'tag':'li',
                        //             $text:'企业信息'
                        //         }]
                        //     }]
                        // }, {
                        //     tag:'li',
                        //     'class':'shopping-help',
                        //     $html:[{
                        //         'class':'title footer-label',
                        //         $text:'购物帮助'
                        //     },{
                        //         'class':'list',
                        //         tag:'ul',
                        //         $html:[{
                        //             tag:'li',
                        //             $text:'相关支付'
                        //         },{
                        //             tag:'li',
                        //             $text:'配送'
                        //         },{
                        //             tag:'li',
                        //             $text:'退货'
                        //         },{
                        //             tag:'li',
                        //             $text:'发票'
                        //         },{
                        //             tag:'li',
                        //             $text:'保养与维修'
                        //         }]
                        //     }]
                        // },{
                        //     'class':'link',
                        //     tag:'li',
                        //     $html:[{
                        //         'class':'title',
                        //         $text:'友情链接'
                        //     },{
                        //         'class':'list',
                        //         tag:'ul',
                        //         $html:[{
                        //             tag:'li',
                        //             $text:'A.R.T.官网'
                        //         },{
                        //             tag:'li',
                        //             $text:'美克美家'
                        //         }]
                        //     }]
                        // },{
                        //     'class':'need-help',
                        //     tag:'li',
                        //     $html:[{
                        //         'class':'title footer-label',
                        //         $text:'需要帮助'
                        //     },{
                        //         'class':'list',
                        //         tag:'ul',
                        //         $html:[{
                        //             tag:'li',
                        //             $text:'联系我们'
                        //         },{
                        //             tag:'li',
                        //             $text:'常见问题'
                        //         }]
                        //     }]
                        // }]
                    }, {
                        'class': 'footer-list-2',
                        tag: 'ul',
                        $html: [{
                            'class': 'notice',
                            tag: 'li',
                            $html: [{
                                'class': 'title footer-label',
                                $text: '关注我们'
                            }, {
                                'class': "list",
                                tag: 'ul',
                                $html: [{
                                    'class': 'weibo',
                                    tag: 'li',
                                    $html: [{
                                        tag: 'a',
                                        target: '_blank',
                                        href: 'http://weibo.com/u/5633603200',
                                        $html: [{
                                            // 'class': 'icon iconfont icon-weibo1',
                                            tag: 'img',
                                            src: './image/icon/weibo.png'
                                        }, {
                                            'class': 'text',
                                            tag: 'span',
                                            $text: '新浪微博'
                                        }]
                                    }]
                                    // }, {
                                    //     'class': 'online-help',
                                    //     tag: 'li',
                                    //     $html: [{
                                    //         'class': 'icon iconfont icon-xinxi9',
                                    //         tag: 'span'
                                    //     }, {
                                    //         'class': 'text',
                                    //         tag: 'span',
                                    //         $text: '在线客服'
                                    //     }]
                                    // }, {
                                    //     'class': 'tel',
                                    //     tag: 'li',
                                    //     $html: [{
                                    //         'class': 'icon iconfont icon-dianhua',
                                    //         tag: 'span'
                                    //     }, {
                                    //         'class': 'text',
                                    //         tag: 'span',
                                    //         $text: '400-6355-728'
                                    //     }]
                                }, {
                                    'class': 'weChat',
                                    tag: 'li',
                                    $html: [{
                                        tag: 'img',
                                        src: './image/icon/wechat.png'
                                    }, {
                                        'class': 'text',
                                        tag: 'span',
                                        $text: '微信公众号'
                                    }, {
                                        tag: 'ul',
                                        'class': 'code-wrapper clearfix',
                                        $html: [{
                                            tag: 'li',
                                            $html: [{
                                                tag: 'img',
                                                src: './image/icon/dingyue.png'
                                            }, {
                                                'class': 'code-title',
                                                $text: '微信订阅号'
                                            }]
                                        }, {
                                            tag: 'li',
                                            $html: [{
                                                tag: 'img',
                                                src: './image/icon/fuwu.png'
                                            }, {
                                                'class': 'code-title',
                                                $text: '微信服务号'
                                            }]
                                        }]
                                    }]
                                }]
                            }]
                        }
                            // ,{
                            //     'class':'subscription-email',
                            //     tag:'li',
                            //     $html:[{
                            //         'class':'title',
                            //         $text:'订阅电子邮件'
                            //     },{
                            //         'class':'desc',
                            //         $text:'通过订阅，那代表您接收A.R.T西区的隐私政策条款'
                            //     },{
                            //         'class':'mail-input',
                            //         $type:inputSubmit,
                            //         $model:'mailInput'
                            //     }]
                            // }
                        ]
                    }, {
                        'class': 'footer-list-3',
                        tag: 'ul',
                        $html: [{
                            'class': 'contact',
                            tag: 'li',
                            $html: [{
                                'class': 'title footer-label',
                                $text: '联系我们'
                            }, {
                                'class': "list",
                                tag: 'ul',
                                $html: [{
                                    //     'class': 'after-sales',
                                    //     tag: 'li',
                                    //     $text: '联系电话：400-635-5728'
                                    // },{
                                    'class': 'after-sales',
                                    tag: 'li',
                                    $html: [{
                                        tag: 'span',
                                        $text: '售后热线'
                                    }, {
                                        tag: 'span',
                                        $text: '：400-060-3372'
                                    }]
                                }, {
                                    'class': 'phone',
                                    tag: 'li',
                                    $html: [{
                                        tag: 'span',
                                        $text: '电话/传真'
                                    }, {
                                        tag: 'span',
                                        $text: '：021-33568989'
                                    }]
                                },{
                                    tag:'li',
                                    'class': '',
                                    $text:' 渠道开发一部总经理  高巍'
                                },{
                                    'class': 'phone',
                                    tag: 'li',
                                    $html: [{
                                        tag: 'span',
                                        $text: '加盟电话'
                                    }, {
                                        tag: 'span',
                                        $text: '：13802069701'
                                    }]
                                }, {
                                    tag:'li',
                                    'class': '',
                                    $text:'渠道开发二部副总经理 胡铁锋'
                                },{
                                    'class': 'phone',
                                    tag: 'li',
                                    $html: [{
                                        tag: 'span',
                                        $text: '加盟电话'
                                    }, {
                                        tag: 'span',
                                        $text: '：13528655618'
                                    }]
                                }, {
                                    'class': 'address',
                                    tag: 'li',
                                    $html: [{
                                        tag: 'span',
                                        $text: '公司地址'
                                    }, {
                                        tag: 'span',
                                        $text: '：上海市徐汇区宜山路407号 尚光徐汇中心金座17楼'
                                    }]
                                }]
                            }]
                        }
                            // ,{
                            //     'class':'subscription-email',
                            //     tag:'li',
                            //     $html:[{
                            //         'class':'title',
                            //         $text:'订阅电子邮件'
                            //     },{
                            //         'class':'desc',
                            //         $text:'通过订阅，那代表您接收A.R.T西区的隐私政策条款'
                            //     },{
                            //         'class':'mail-input',
                            //         $type:inputSubmit,
                            //         $model:'mailInput'
                            //     }]
                            // }
                        ]
                    }, {
                        'class': 'footer-list-4',
                        tag: 'ul',
                        $html: [{
                            'class': 'friendly-link',
                            tag: 'li',
                            $html: [{
                                'class': 'title footer-label',
                                $text: '友情链接'
                            }, {
                                'class': "list",
                                tag: 'ul',
                                $html: [{
                                    tag: 'li',
                                    $html: {
                                        'class': 'link-mkf',
                                        tag: 'a',
                                        href: 'http://www.markorhome.com/',
                                        target: '_blank',
                                        $html: {
                                            tag: 'img',
                                            src: './image/logo/mkf1.svg'
                                        }
                                    }
                                }, {
                                    tag: 'li',
                                    $html: {
                                        'class': 'link-art',
                                        tag: 'a',
                                        href: 'http://www.artfurniture.com.cn/',
                                        target: '_blank',
                                        $html: {
                                            tag: 'img',
                                            src: './image/logo/art.svg'
                                        }
                                    }
                                }, {
                                    tag: 'li',
                                    $html: {
                                        'class': 'link-zest',
                                        tag: 'a',
                                        href: 'http://www.zeststore.com/',
                                        target: '_blank',
                                        $html: {
                                            tag: 'img',
                                            src: './image/logo/zest.svg'
                                        }
                                    }
                                    // }, {
                                    //     tag: 'li',
                                    //     $html: {
                                    //         'class': 'link-ethanallen',
                                    //         tag: 'a',
                                    //         href: 'http://www.ethanallen.com/',
                                    //         target: '_blank',
                                    //         $html: {
                                    //             tag: 'img',
                                    //             src: './image/logo/ethanallen.svg'
                                    //         }
                                    //     }
                                }, {
                                    tag: 'li',
                                    $html: {
                                        'class': 'link-caracole',
                                        tag: 'a',
                                        href: 'https://caracole.com/',
                                        target: '_blank',
                                        $html: {
                                            tag: 'img',
                                            src: './image/logo/caracole.svg'
                                        }
                                    }

                                }, {
                                    tag: 'li',
                                    $html: {
                                        'class': 'link-yvvy',
                                        tag: 'a',
                                        href: 'http://www.yvvy.cn',
                                        target: '_blank',
                                        $html: {
                                            tag: 'img',
                                            src: './image/logo/yvvy.png'
                                        }
                                    }
                                }]
                            }]
                        }
                            // ,{
                            //     'class':'subscription-email',
                            //     tag:'li',
                            //     $html:[{
                            //         'class':'title',
                            //         $text:'订阅电子邮件'
                            //     },{
                            //         'class':'desc',
                            //         $text:'通过订阅，那代表您接收A.R.T西区的隐私政策条款'
                            //     },{
                            //         'class':'mail-input',
                            //         $type:inputSubmit,
                            //         $model:'mailInput'
                            //     }]
                            // }
                        ]
                    }]
            }, {
                'class': 'footer-record',
                $html: [{
                    tag:'a',
                    'class': 'footer-record-3',
                    href:'http://www.beian.miit.gov.cn/',
                    target:'_blank',
                    $text: 'COPYRIGHT 2003-2018 美克家居 新ICP：05003017号-7 美克国际家居用品股份有限公司'
                    // }, {
                    //     // 'class':'footer-record-1',
                    //     // $text:'©2017 某 保留所有权利'
                    // }, {
                    //     // 'class':'footer-record-2',
                    //     // $text:'沪ICP备13010397号-2'
                }]
            }]
        }
    },
    method: {
        init: function () {
            nb.model.onChange(nb.opts.clientReady, function () {
                $(".footer-label").click(function () {
                    var width = document.body.clientWidth;
                    if (width < 768) {
                        $(this).toggleClass('active').next("ul").slideToggle(300).siblings("ul").slideUp("slow");
                        $(this).parent().addClass("current").siblings().removeClass("current");
                    }
                    //slideToggle通过使用滑动效果，在显示和隐藏状态之间切换
                });                   //siblings() 方法返回被选元素的所有同级元素。
            }, this);                 //slideUp()通过使用滑动效果，隐藏被选元素，如果元素已显示出来的话。
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ../src/js/view/Footer.js
// module id = 28
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32